import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { selectAllImages, clearImageSelection } from '../../actions/SearchFieldActions';
import './SelectedImagePaper.sass';

class SelectedImagePaper extends Component {
  constructor(props) {
    super(props);
    this.handleSelectAllImages = this.handleSelectAllImages.bind(this);
    this.handleDeselectAllImages = this.handleDeselectAllImages.bind(this);
    this.handleBatchEvaluation = this.handleBatchEvaluation.bind(this);
  }

  handleSelectAllImages() {
    const { dispatch } = this.props;
    dispatch(selectAllImages());
  }

  handleDeselectAllImages() {
    const { dispatch } = this.props;
    dispatch(clearImageSelection());
  }

  handleBatchEvaluation() {
    const { history /* , query */ } = this.props;
    history.push('/images/batch_evaluation');
  }

  render() {
    const { selectedImages, history } = this.props;

    const isGridDisplayPage = /\/images\/grid/.test(history.location.pathname);
    const imgCount = selectedImages.size;

    return (
      <div className={`SelectedImagePaper
        ${imgCount !== 0 && isGridDisplayPage ? 'show' : ''}`}
      >
        {imgCount} Selected <span className="fa fa-check" />

        <div className="detail">
          <button onClick={this.handleSelectAllImages}>
            <span className="fa fa-check" /> Select All
          </button>
          <button onClick={this.handleDeselectAllImages}>
            <span className="fa fa-times" /> Deselect All
          </button>
          <button onClick={this.handleBatchEvaluation}>
            <span className="fa fa-pie-chart" /> Evaluate
          </button>
        </div>
      </div>
    );
  }
}

SelectedImagePaper.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  selectedImages: PropTypes.object.isRequired
};

function mapStateToProps(store) {
  const { SearchField: { selectedImages } } = store;

  return { selectedImages };
}

export default withRouter(connect(mapStateToProps)(SelectedImagePaper));



// WEBPACK FOOTER //
// ./src/containers/Main/SelectedImagePaper.jsx